module.exports = __webpack_public_path__ + "img/cards-blue-black.9f18a9c1.svg";